import React, { memo } from 'react';
import { RecordVoicemailContainerProps } from './type';
import RecordVoicemail from './record-voicemail';

const RecordVoicemailContainer: React.FC<RecordVoicemailContainerProps> = ({
  show,
  onClose,
  onSave,
  fromSettings = false,
  templateId,
  defaultTitle,
  initialAudioUrl,
  existingAudioFileKey,
  defaultDuration,
  editMode,
  defaultLanguage,
  hideLanguageSelection,
  isDemoAccount,
}) => (
  <RecordVoicemail
    show={show}
    onClose={onClose}
    onSave={onSave}
    fromSettings={fromSettings}
    templateId={templateId}
    defaultTitle={defaultTitle}
    initialAudioUrl={initialAudioUrl}
    existingAudioFileKey={existingAudioFileKey}
    defaultDuration={defaultDuration}
    editMode={editMode}
    defaultLanguage={defaultLanguage}
    hideLanguageSelection={hideLanguageSelection}
    isDemoAccount={isDemoAccount}
  />
);
export default memo(RecordVoicemailContainer);
